export default __webpack_public_path__ + "static/img/landing_girl.202f7d0.jpg";